export interface Place {
  code: string;
  name: string;
  type: string;
}

export interface PlacesRequest {
  search: string;
  locale?: string;
  resultSize?: number;
}

export interface PlacesSearchResultCallback {
  onSearchResult?: (places: Place[]) => void;
}

export enum PlacesActionTypes {
  PLACES_FETCH_REQUEST = "@PlaceSelector/PLACES_FETCH_REQUEST",
  PLACES_FETCH_SUCCESS = "@PlaceSelector/PLACES_FETCH_SUCCESS",
  PLACES_FETCH_ERROR = "@PlaceSelector/PLACES_FETCH_ERROR",
}

export interface PlacesSelectorState {
  places: Place[];
}
